import React from 'react'
import { NavLink } from 'react-router-dom'
import Authorization from './../../utils/Authorization'

const NavLinkBook = ({ url, label, permissions, activeClassName }) => (
  <NavLink to='/books' className='nav-item' activeClassName={activeClassName}>
    <span>Livros</span>
  </NavLink>
)

export default Authorization(['can_add_book_to_adoption_lists'])(NavLinkBook)



// WEBPACK FOOTER //
// ./src/components/Menu/NavLinkBook.js